import { useEffect } from 'react';

import { Trans } from '@lingui/react/macro';
import { useOktaAuth } from '@okta/okta-react';

const IdpLogin = () => {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    oktaAuth.signInWithRedirect({});
  }, [oktaAuth]);

  return (
    <div>
      <Trans>loading...</Trans>
    </div>
  );
};

export default IdpLogin;
